import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import { isCollectionComplete } from './is-collection-complete';

export interface IPipelineProgress {
  collectionsTotal: number;
  collectionsComplete: number;
  triagedDone: number;
  triagedTotal: number;
  publishedDone: number;
  publishedTotal: number;
}

export function aggregatePipelineProgress(items: ICollectionPipelineStatusV3[]): IPipelineProgress {
  return items.reduce<IPipelineProgress>(
    (acc, item) => {
      const { steps } = item;
      acc.triagedDone += steps.triaged?.done ?? 0;
      acc.triagedTotal += steps.triaged?.total ?? 0;
      acc.publishedDone += steps.published.done;
      acc.publishedTotal += steps.published.total;
      if (isCollectionComplete(item, undefined)) {
        acc.collectionsComplete += 1;
      }
      return acc;
    },
    {
      collectionsTotal: items.length,
      collectionsComplete: 0,
      triagedDone: 0,
      triagedTotal: 0,
      publishedDone: 0,
      publishedTotal: 0,
    },
  );
}
